import { connect } from 'react-fela'; // eslint-disable-line behance/no-deprecated

import getReactDisplayName from 'react-display-name';
export function createComponentStyles(styleFunctions, component) {
  var ConnectedComponent = connect(styleFunctions)(component);
  ConnectedComponent.displayName = getReactDisplayName(component);
  return ConnectedComponent;
}
export default createComponentStyles;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/style-container/es/createComponentStyles.js
// module id = 1285
// module chunks = 0